import React from 'react';

/**
 * Native OpenBro app frames used in the sales page.
 * Screens list the real formation modules and lesson titles.
 */

const MODULES = [
  { name: 'Musculation & Discipline', short: 'Musculation', coach: 'Léo', lessons: 31, done: 12, color: '#FF5A36' },
  { name: 'E-commerce & Réseaux', short: 'E-commerce', coach: 'Lisa', lessons: 18, done: 4, color: '#3D8BFF' },
  { name: 'Montage Vidéo Pro', short: 'Montage', coach: 'Astroworld', lessons: 16, done: 7, color: '#7A5CFF' },
  { name: 'Tournage & Filming', short: 'Tournage', coach: 'Another World', lessons: 16, done: 2, color: '#F0A202' },
  { name: 'IA & Automatisation', short: 'IA', coach: 'Rémi', lessons: 12, done: 5, color: '#21C7B7' },
  { name: 'Nutrition & Performance', short: 'Nutrition', coach: 'Gaut', lessons: 16, done: 9, color: '#3DDC72' },
];

function Phone({ children, className = '' }) {
  return (
    <div className={`obn-phone ${className}`}>
      <div className="obn-screen">
        <div className="obn-status"><span>9:41</span><span>5G</span></div>
        {children}
        <div className="obn-home" />
      </div>
    </div>
  );
}

function TabBar({ active }) {
  const tabs = ['Accueil', 'Modules', 'Vision', 'Profil'];
  return (
    <div className="obn-tabs">
      {tabs.map((tab) => (
        <span key={tab} className={tab === active ? 'is-on' : ''}>{tab}</span>
      ))}
    </div>
  );
}

function LessonRows({ rows }) {
  return (
    <div className="obn-list">
      {rows.map((row) => (
        <div key={row.title} className={`obn-row ${row.now ? 'is-now' : ''}`}>
          <span className="obn-mark">{row.done ? '✓' : row.now ? '▶' : ''}</span>
          <span className="obn-row-title">{row.title}</span>
          <span className="obn-time">{row.time}</span>
        </div>
      ))}
    </div>
  );
}

function PhotoHero({ src, kicker, title, meta }) {
  return (
    <div className="obn-hero-photo" style={{ backgroundImage: `url(${src})` }}>
      <span>{kicker}</span>
      <strong>{title}</strong>
      <em>{meta}</em>
    </div>
  );
}

export function ModulesHome() {
  return (
    <>
      <PhotoHero src="/cover-train.jpg" kicker="Séance du jour" title="Full Body" meta="45 min · Léo" />
      <div className="obn-photo-row">
        <div style={{ backgroundImage: 'url(/cover-food.jpg)' }}><b>Nutrition</b></div>
        <div style={{ backgroundImage: 'url(/cover-video.jpg)' }}><b>Montage</b></div>
        <div style={{ backgroundImage: 'url(/cover-city.jpg)' }}><b>Business</b></div>
      </div>
      <TabBar active="Accueil" />
    </>
  );
}

export function MusculationLessons() {
  return (
    <>
      <PhotoHero src="/cover-train.jpg" kicker="Léo · 12/31" title="Musculation" meta="Deviens plus fort" />
      <LessonRows rows={[
        { title: 'La Physiologie Musculaire', time: '15:00', now: true },
        { title: 'Programme Full Body', time: '25:00' },
      ]} />
      <TabBar active="Modules" />
    </>
  );
}

function NutritionLessons() {
  return (
    <>
      <PhotoHero src="/cover-food.jpg" kicker="Gaut · 9/16" title="Nutrition" meta="Plan Sèche" />
      <LessonRows rows={[
        { title: 'Macros — Protéines, Glucides, Lipides', time: '20:00', done: true },
        { title: 'Plan Prise de Masse — 3000 kcal', time: '25:00', done: true },
        { title: 'Plan Sèche — Perdre du gras', time: '25:00', now: true },
        { title: 'Meal Prep — 5 jours en 2h', time: '30:00' },
        { title: 'Créatine — Le guide complet', time: '18:00' },
      ]} />
      <TabBar active="Modules" />
    </>
  );
}

function MontageLessons() {
  return (
    <>
      <PhotoHero src="/cover-video.jpg" kicker="Astroworld · 7/16" title="Montage" meta="Reel viral" />
      <div className="obn-player">
        <span>En cours</span>
        <strong>Monter un Reel viral en 30 min</strong>
        <i />
      </div>
      <LessonRows rows={[
        { title: 'Les coupes qui rendent accro', time: '18:00', done: true },
        { title: 'Le rythme — Sync son et image', time: '20:00', done: true },
        { title: 'Color grading — Look ciné', time: '25:00' },
        { title: 'Exporter pour chaque plateforme', time: '15:00' },
      ]} />
      <TabBar active="Modules" />
    </>
  );
}

function TournageLessons() {
  return (
    <>
      <PhotoHero src="/cover-video.jpg" kicker="Another World" title="Tournage" meta="Ton iPhone, une caméra" />
      <LessonRows rows={[
        { title: 'Ton iPhone est une caméra de cinéma', time: '12:00', done: true },
        { title: 'Réglages iPhone — Comme un pro', time: '20:00', now: true },
        { title: 'Cadrage et composition', time: '25:00' },
        { title: 'La lumière naturelle', time: '22:00' },
        { title: 'Filmer une pub produit', time: '25:00' },
      ]} />
      <TabBar active="Modules" />
    </>
  );
}

function IaLessons() {
  return (
    <>
      <PhotoHero src="/cover-city.jpg" kicker="Rémi · 5/12" title="IA" meta="Automatise pendant que tu dors" />
      <LessonRows rows={[
        { title: 'ChatGPT, Claude, Gemini', time: '30:00', done: true },
        { title: 'L’Art du Prompt', time: '25:00', done: true },
        { title: 'Make.com — Automatiser sans coder', time: '35:00', now: true },
        { title: 'Chatbots IA — Assistant virtuel', time: '30:00' },
        { title: 'Agents IA — Le niveau supérieur', time: '28:00' },
      ]} />
      <TabBar active="Modules" />
    </>
  );
}

function Pair({ back, front, flip }) {
  return (
    <div className={`obn-pair ${flip ? 'is-flip' : ''}`}>
      <Phone className="is-back">{back}</Phone>
      <Phone className="is-front">{front}</Phone>
    </div>
  );
}

export function DisciplineScene() {
  return <Pair back={<MusculationLessons />} front={<NutritionLessons />} />;
}

export function ContentScene() {
  return <Pair flip back={<TournageLessons />} front={<MontageLessons />} />;
}

export function IaScene() {
  return <Pair back={<ModulesHome />} front={<IaLessons />} />;
}

function ColorHome() {
  return (
    <>
      <PhotoHero src="/cover-train.jpg" kicker="Continuer" title="Physiologie" meta="Musculation · 15:00" />
      <div className="obn-tiles">
        {MODULES.map((mod) => (
          <div key={mod.short} className="obn-tile" style={{ background: mod.color }}>
            <strong>{mod.short}</strong>
            <em>{mod.done}/{mod.lessons}</em>
          </div>
        ))}
      </div>
      <TabBar active="Accueil" />
    </>
  );
}

function ColorPlayer() {
  return (
    <>
      <PhotoHero src="/cover-video.jpg" kicker="Lecture" title="Reel viral" meta="Montage · 30:00" />
      <LessonRows rows={[
        { title: 'Les coupes qui rendent accro', time: '18:00', done: true },
        { title: 'Sync son et image', time: '20:00', now: true },
        { title: 'Color grading — Look ciné', time: '25:00' },
      ]} />
      <TabBar active="Modules" />
    </>
  );
}

function ColorSession() {
  return (
    <>
      <PhotoHero src="/cover-food.jpg" kicker="Séance" title="Full Body" meta="Programme Léo" />
      <div className="obn-tiles">
        <div className="obn-tile" style={{ background: '#3DDC72' }}><strong>Plan Sèche</strong><em>25:00</em></div>
        <div className="obn-tile" style={{ background: '#F0A202' }}><strong>Réglages iPhone</strong><em>20:00</em></div>
        <div className="obn-tile" style={{ background: '#FF5A36' }}><strong>Make.com</strong><em>35:00</em></div>
        <div className="obn-tile" style={{ background: '#7A5CFF' }}><strong>Agents IA</strong><em>28:00</em></div>
      </div>
      <TabBar active="Vision" />
    </>
  );
}

export function PlatformStage() {
  return (
    <div className="obn-stage">
      <Phone className="obn-stage-phone is-a"><ColorHome /></Phone>
      <Phone className="obn-stage-phone is-b"><ColorPlayer /></Phone>
      <Phone className="obn-stage-phone is-c"><ColorSession /></Phone>
    </div>
  );
}

export function TakeActionPhones() {
  return (
    <div className="obn-pair obn-pair-hero">
      <Phone className="is-back">{<ModulesHome />}</Phone>
      <Phone className="is-front">{<MusculationLessons />}</Phone>
    </div>
  );
}

export const nativeMockStyles = `
  .obn-pair { position: relative; width: 340px; height: 420px; }
  .obn-pair-hero { width: 100%; height: 100%; }
  .obn-phone { position: absolute; border-radius: 28px; padding: 7px; background: #0a0d14; box-shadow: 0 24px 50px rgba(0,0,0,0.45); }
  .obn-pair .is-back { width: 168px; height: 340px; left: 0; bottom: 0; transform: rotate(-8deg); z-index: 1; }
  .obn-pair .is-front { width: 196px; height: 400px; right: 0; top: 0; transform: rotate(6deg); z-index: 2; }
  .obn-pair-hero .is-back { width: 188px; height: 390px; left: 8%; top: 40px; }
  .obn-pair-hero .is-front { width: 220px; height: 460px; right: 6%; top: 8px; }
  .obn-screen { height: 100%; border-radius: 22px; background: #05070c; color: #f4f7fb; overflow: hidden; display: flex; flex-direction: column; font-family: Inter, -apple-system, sans-serif; position: relative; }
  .obn-status { display: flex; justify-content: space-between; padding: 8px 12px 0; font-size: 10px; letter-spacing: 0.04em; color: rgba(255,255,255,0.7); }
  .obn-kicker { margin: 8px 12px 0; font-size: 9px; letter-spacing: 0.18em; text-transform: uppercase; color: rgba(255,255,255,0.45); }
  .obn-title { margin: 2px 12px 0; font-size: 20px; line-height: 1.1; font-family: "Space Grotesk", Inter, sans-serif; }
  .obn-sub { margin: 2px 12px 6px; font-size: 10px; color: rgba(255,255,255,0.5); }
  .obn-section { margin: 8px 12px 2px; font-size: 9px; letter-spacing: 0.14em; text-transform: uppercase; color: rgba(255,255,255,0.4); }
  .obn-list { padding: 4px 8px; display: flex; flex-direction: column; gap: 4px; }
  .obn-mod, .obn-row { display: flex; align-items: center; gap: 6px; background: rgba(255,255,255,0.06); border-radius: 10px; padding: 6px 8px; }
  .obn-swatch { width: 8px; height: 28px; border-radius: 99px; flex: none; }
  .obn-hero-card { margin: 8px; padding: 12px; border-radius: 16px; color: #1a120c; }
  .obn-hero-card span, .obn-cover em { display: block; font-size: 9px; letter-spacing: 0.12em; text-transform: uppercase; opacity: 0.75; }
  .obn-hero-card strong { display: block; margin-top: 4px; font-size: 14px; line-height: 1.15; }
  .obn-hero-card em { display: block; margin-top: 4px; font-style: normal; font-size: 10px; }
  .obn-tiles { display: grid; grid-template-columns: 1fr 1fr; gap: 6px; padding: 0 8px 8px; }
  .obn-tile { border-radius: 12px; padding: 8px; min-height: 52px; color: #14120f; }
  .obn-tile strong { display: block; font-size: 11px; line-height: 1.15; }
  .obn-tile em { font-style: normal; font-size: 9px; opacity: 0.75; }
  .obn-cover { margin: 8px; border-radius: 16px; min-height: 120px; padding: 12px; display: flex; flex-direction: column; justify-content: flex-end; }
  .obn-cover span { width: 28px; height: 28px; border-radius: 50%; background: #fff; color: #2A1B6B; display: grid; place-items: center; font-size: 11px; margin-bottom: 8px; }
  .obn-cover strong { font-size: 14px; line-height: 1.15; }
  .obn-stage { display: flex; justify-content: center; align-items: flex-end; gap: 14px; min-height: 390px; padding: 28px 12px 0; }
  .obn-stage-phone { position: relative; width: 190px; height: 380px; }
  .obn-stage-phone.is-a { transform: rotate(-7deg) translateY(18px); }
  .obn-stage-phone.is-b { width: 220px; height: 430px; z-index: 2; }
  .obn-stage-phone.is-c { transform: rotate(7deg) translateY(22px); }
  .obn-mod { justify-content: space-between; }
  .obn-mod strong, .obn-row-title { display: block; font-size: 10px; font-weight: 600; line-height: 1.2; }
  .obn-mod em { display: block; font-style: normal; font-size: 9px; color: rgba(255,255,255,0.45); }
  .obn-mod b { font-size: 10px; font-weight: 600; color: #e6ebf2; }
  .obn-mark { width: 12px; font-size: 9px; color: #e6ebf2; flex: none; }
  .obn-row-title { flex: 1; }
  .obn-time { font-size: 9px; color: rgba(255,255,255,0.4); flex: none; }
  .obn-row.is-now { outline: 1px solid rgba(255,255,255,0.28); }
  .obn-player { margin: 6px 8px; padding: 8px; border-radius: 12px; background: #10151e; }
  .obn-player span { font-size: 9px; letter-spacing: 0.12em; text-transform: uppercase; color: rgba(255,255,255,0.45); }
  .obn-player strong { display: block; margin-top: 2px; font-size: 11px; }
  .obn-player i { display: block; margin-top: 8px; height: 3px; border-radius: 99px; background: linear-gradient(90deg, #f4f7fb 42%, rgba(255,255,255,0.15) 42%); }
  .obn-tabs { margin-top: auto; display: grid; grid-template-columns: repeat(4, 1fr); border-top: 1px solid rgba(255,255,255,0.08); padding: 6px 0 2px; }
  .obn-tabs span { text-align: center; font-size: 8px; letter-spacing: 0.04em; color: rgba(255,255,255,0.35); }
  .obn-tabs .is-on { color: #f4f7fb; }
  .obn-home { width: 72px; height: 4px; border-radius: 99px; background: rgba(255,255,255,0.7); margin: 4px auto 6px; }
  .obn-hero-photo { margin: 8px 8px 0; min-height: 168px; flex: 1; border-radius: 16px; background-size: cover; background-position: center; display: flex; flex-direction: column; justify-content: flex-end; padding: 10px; position: relative; }
  .obn-hero-photo::after { content: ""; position: absolute; inset: 0; border-radius: 16px; background: linear-gradient(180deg, rgba(0,0,0,0.05) 20%, rgba(0,0,0,0.78) 100%); }
  .obn-hero-photo span, .obn-hero-photo strong, .obn-hero-photo em { position: relative; z-index: 1; }
  .obn-hero-photo span { font-size: 9px; letter-spacing: 0.14em; text-transform: uppercase; color: #ffb25a; }
  .obn-hero-photo strong { font-size: 20px; line-height: 1.05; font-family: "Space Grotesk", Inter, sans-serif; }
  .obn-hero-photo em { font-style: normal; font-size: 11px; color: rgba(255,255,255,0.85); }
  .obn-photo-row { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 6px; padding: 8px; }
  .obn-photo-row div { height: 72px; border-radius: 12px; background-size: cover; background-position: center; display: flex; align-items: flex-end; padding: 6px; }
  .obn-photo-row b { font-size: 9px; text-shadow: 0 1px 4px #000; }
  @media (max-width: 700px) {
    .obn-stage { transform: scale(0.62); transform-origin: top center; min-height: 280px; margin-bottom: -80px; }
  }
  @media (max-width: 1023px) {
    .obn-pair { transform: scale(0.86); transform-origin: center top; }
    .obn-pair-hero .is-back { left: 4%; }
    .obn-pair-hero .is-front { right: 2%; }
  }
`;
